export const IMAGE_PRESETS = {
  default: {
    src: 'medium',
    sizes: '100vw',
    loading: 'lazy',
    objectFit: 'cover',
  },
  avatar: {
    src: 'thumbnail',
    sizes: '80px',
    loading: 'lazy',
    objectFit: 'cover',
    round: true,
  },
  brandCard: {
    src: 'medium',
    sizes: '(max-width: 768px) 100vw, 415px',
    loading: 'lazy',
    objectFit: 'cover',
  },
  brandRoundIcon: {
    src: 'thumbnail',
    sizes: '40px',
    loading: 'lazy',
    objectFit: 'cover',
    round: true,
  },
  brandGallery: {
    src: 'medium',
    sizes: '(max-width: 768px) calc(100vw - 40px), 290px',
    loading: 'lazy',
    objectFit: 'cover',
  },
  brandDetailHero: {
    src: 'medium',
    sizes: '(max-width: 768px) calc(100vw - 40px), 235px',
    loading: 'eager',
    objectFit: 'cover',
  },
  brandPromo: {
    src: 'large',
    sizes: '(max-width: 768px) calc(100vw - 40px), 656px',
    loading: 'lazy',
    objectFit: 'cover',
  },
  companyLogo: {
    src: 'small',
    sizes: '(max-width: 900px) 70px, 220px',
    loading: 'lazy',
    objectFit: 'contain',
  },
  companyLogoCompact: {
    src: 'small',
    sizes: '32px',
    loading: 'lazy',
    objectFit: 'contain',
  },
  articleCard: {
    src: 'medium',
    sizes: '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 365px',
    loading: 'lazy',
    objectFit: 'contain',
  },
  articleFeature: {
    src: 'medium',
    sizes: '(max-width: 768px) 100vw, 490px',
    loading: 'lazy',
    objectFit: 'contain',
  },
  articleHero: {
    src: 'large',
    sizes: '(max-width: 768px) calc(100vw - 40px), 690px',
    loading: 'eager',
    objectFit: 'cover',
  },
  loyaltyStatusIcon: {
    src: 'thumbnail',
    sizes: '20px',
    loading: 'lazy',
    objectFit: 'contain',
  },
  selectionLogo: {
    src: 'thumbnail',
    sizes: '32px',
    loading: 'lazy',
    objectFit: 'contain',
  },
};
